import { get, post } from '../http';

const fetch = () => get('schoolGroupsRetrieve');
const save = (id, data) => {
  let url = 'schoolGroupSave';
  if (id) {
    url += '?id=' + id;
  }
  return post(url, data);
};

export default {
  fetch,
  save,
};
